module.exports = __webpack_public_path__ + "media/webfonts/fa-regular-400-491974d1.ttf";